<template>
  <v-select :value="value" :items="studios" item-text="name" item-value="_id" :label="label" :multiple="multiple" :small-chips="multiple" :deletable-chips="multiple" :disabled="disabled" :loading="loading"
    outlined dense hide-details prepend-inner-icon="mdi-map-marker-outline" class="pos-studio-select" :menu-props="{ maxHeight: 340, offsetY: true }" @change="$emit('input', $event)">
    <template v-if="multiple" #selection="{ item, index }"><span v-if="index === 0" class="v-select__selection">{{ value.length === 1 ? item.name : value.length + ' Studios' }}</span></template>
  </v-select>
</template>
<script>
export default {
  props: { value: { type: [String, Array], default: "" }, studios: { type: Array, default: () => [] }, label: { type: String, default: "Studio" }, multiple: Boolean, disabled: Boolean, loading: Boolean },
}
</script>
